
import React from 'react';
import ReactModal from 'react-modal';
import { withRouter } from 'react-router-dom';
import $ from 'jquery';


import VisuelFleche from '../visuels/Fleche.png';
import AffichageProduitsSelectionnes from "./AffichageProduitsSelectionnes";
import AffichageProduit from "./AffichageProduit";

import LogoV33 from '../visuels/logoV33.jpg';
import JaiTermine from '../visuels/j-ai-termine.png';
class VisualiseurV33 extends React.Component {


    redirectToPieces = () => {
        const { history } = this.props;
        if(history) history.push('/pieces');
    }

    redirectToHome = () => {
        const {history} = this.props;
        if (history) history.push('/');
    };

    redirectToInfo = () => {
        const { history } = this.props;
        if(history) history.push('/infos');
    }


    redirectToBack = () => {
        const {history} = this.props;
        if (history) history.goBack();
    };

    redirectToAfficherProduits = () => {
        this.setState({AffichageVisualiseur:false,AffichageProduits : true, AffichageProduit :false})
    };
    redirectToAfficherProduit = (produit) => {
        this.produitAAfficher = produit;
        this.setState({AffichageVisualiseur:false,AffichageProduits : false, AffichageProduit :true})
    };
    redirectToVisualiseur = () => {
        this.setState({AffichageVisualiseur:true,AffichageProduits : false,AffichageProduit : false})
    };


    constructor(props)
    {
        super(props);
        const {params} = this.props.match;
        this.state = {NbProduits: 0,AffichageProduit :false, AffichageProduits : false,AffichageVisualiseur:true,
            showModal: false};
        this.gamme = params.piece;

        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);

    }

    componentDidMount() {
        $('body').addClass('v33');
        fetch(process.env.PUBLIC_URL + "/visualiseur/data_" + this.gamme + ".json")
            .then(res => res.json())
            .then(
                (result) => {

                    this.visualiseurSetData(
                        result, this.piece
                    );

                    fetch(process.env.PUBLIC_URL + "/visualiseur/" + this.gamme + "/visuels.json")
                        .then(res => res.json())
                        .then(
                            (result) => {

                                this.visuels = result;
                                this.affichageVisuelsInspi();
                            },
                            (error) => {
                                this.setState({
                                    isLoaded: true,
                                    error
                                });
                            }
                        );
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            );

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.NbProduits > 0 )
        {
            if(prevState.AffichageVisualiseur === false)
            {
                this.afficherCategoriesVisualiseur();
            }
            if(this.state.AffichageVisualiseur === false)
            {
                document.getElementById('visualiseur-categories').innerHTML = '';
            }
        }
    }

    handleOpenModal (harmonie) {
        $('.visualiseur-nuancier-texte-nuance').hide();
        this.setState({ showModal: true });
        this.setState({ harmonie: harmonie });
    }

    handleCloseModal () {
        this.setState({ showModal: false });
        $('.visualiseur-nuancier-texte-nuance').show();
    }

    render() {
        const { history } = this.props;
        const isAffichageProduit = this.state.AffichageProduit;
        const isAffichageProduits = this.state.AffichageProduits;
        const isAffichageSimulateur = this.state.AffichageVisualiseur;
        const NbProduits = 0;
        return  (
            <div className="v33">
            <div className="visualiseur">
                <div className="simulateur">
                {/* <h3>Je crée mon projet</h3> */}
                    
                {/* <p className="visualiseur-aide-categorie">Cochez la zone à coloriser et choisissez une couleur !</p> */}


                <div id="visualiseur-images-categories" className='paysage'>
                    <div id="visualiseur-images" className="v33">
                        <div className="visualiseur-image" id="visualiseur-image">
                        </div>


                    </div>
                    <div id="visualiseur-panneau-droit">
                        <ul className="visualiseur-pieces">
                        </ul>

                        { isAffichageSimulateur ? (
                        <div id="visualiseur-panneau-droit-categories">
                        <div id="visualiseur-liste-categories" className="visualiseur-categories ">

                        </div>
                            <div id="visualiseur-nuanciers" className="animated zoomIn delay-2s">
                            </div>
                    </div>): (<div></div>)}
                    </div>
                </div>

            </div>
                <div className="harmonies">

                    <h2>Laissez-vous guider</h2>
                    {/* <p className='visualiseur-aide-categorie'>Découvrez les harmonies de notre styliste</p>
                    <br/> */}
                    <div className='harmonies-images' id="harmonies-images">
                    </div>
                </div>
            </div>

                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel="">
                    <img title="cliquez sur l'image  pour fermer" src={this.state.harmonie} className='harmonie-image-complete' onClick={this.handleCloseModal}/>

                    <button className='modale-bouton-fermer' onClick={this.handleCloseModal}>Cliquez sur l'image pour fermer</button>
                </ReactModal>
            </div>);
    }

    /**
     * Created by mickael.puyfages on 16/06/2017.
     * Updated by mickael.puyfages on 10/09/2019
     */
     pieces = [];
     pieceSelectionnee = "";
     produits = [];
     categories = [];
     produitsSelectionnes = [];
     visualiseurData = [];
     gammme = "";
     produitsAAfficher = [];
    produitAAfficher = [];
    visuels = [];


    generationNuances = () =>{
        var data = this.visualiseurData;
        this.pieces = data.pieces;
        this.produits = [];
        let htmlPieces = '';
        for (const [key, value] of Object.entries(this.pieces)) {
            if(key.toLowerCase()===this.pieceSelectionnee.toLowerCase()){
                htmlPieces += '<li class="visualiseur-piece active" data-piece="' + key + '">' + value.nom + '</li>';
            }else{
                htmlPieces += '<li class="visualiseur-piece" data-piece="' + key + '">' + value.nom + '</li>';
            }
            

        }
        $('.visualiseur-pieces').html(htmlPieces);
        var gamme = this.gamme;
        data.produits.forEach(function (produit, index) {
            if(produit.gamme == gamme) {
                var categorie = produit.emplacement;
                var piece = produit.piece;

                produit.nuances.forEach(function (nuance) {
                    nuance.produits = produit.id;
                    if (this.pieces[piece].emplacements[categorie] != undefined) {
                        if (!this.contiensNuance(nuance, this.pieces[piece].emplacements[categorie].nuances))
                            this.pieces[piece].emplacements[categorie].nuances.push(nuance);
                        else {
                            var nuance_liste = this.rechercheNuanceNom(nuance.nom,this.pieces[piece].emplacements[categorie].nuances);
                            if (!nuance_liste) {
                                var index_liste = this.pieces[piece].emplacements[categorie].nuances.indexOf(nuance_liste);
                                this.pieces[piece].emplacements[categorie].nuances.splice(index_liste, 1);

                                nuance.produits = nuance.produits + ',' + produit.id;
                                this.pieces[piece].emplacements[categorie].nuances.push(nuance);
                            }
                        }
                    }
                }.bind(this));

                console.log(this.pieces);

                this.produits.push(produit);
            }
        }.bind(this));
        if(this.support_format_webp)
            document.getElementById("visualiseur-image").style.backgroundImage = "url('"+ process.env.PUBLIC_URL + "/visualiseur/"+ this.gamme +"/" + this.pieceSelectionnee + ".png')";
        else
            document.getElementById("visualiseur-image").style.backgroundImage = "url('"+ process.env.PUBLIC_URL + "/visualiseur/"+ this.gamme +"/" + this.pieceSelectionnee + ".png')";
        document.getElementById("visualiseur-image").style.backgroundPosition = "center";

        const self = this;
        this.afficherCategoriesVisualiseur();
        //afficherNuanceProduitVisualiseur();

        $('#visualiseur-pdf-download').bind('click', function (event) {
            this.genererPdf();
        });

        $('.visualiseur-piece').on('click', function () {
            $(this).closest('ul').find('li.active').removeClass('active');
            $(this).addClass('active');
        });

        $('.visualiseur-piece').bind('click', function (event) {
            self.changerPiece(event);
        });
    }

    affichageVisuelsInspi()
    {

        var html = '';
        $('.harmonies-image').unbind('click');
        this.visuels.forEach(function (visuel) {
            if(visuel.piece === this.pieceSelectionnee)
                html += "<img data-complet='" + process.env.PUBLIC_URL + "/visualiseur/" + this.gamme + "/visuels/"+ visuel.img_complet + "'  src='" + process.env.PUBLIC_URL + "/visualiseur/" + this.gamme + "/visuels/"+ visuel.img + "' class='harmonies-image' onClick={this.handleOpenModal}/>";
        }.bind(this));
        $("#harmonies-images").html(html);

        $('.harmonies-image').bind('click', function (event) {
            this.handleOpenModal(event.target.dataset['complet']);
        }.bind(this));
    }

     changerPiece = (e)  =>{
        $("#visualiseur-nuances").html('');
        $(".visualiseur-nuancier-texte-nuance").text('');
        $("[id^='visualiseur-" + this.pieceSelectionnee + "-'").remove();
         this.pieceSelectionnee = e.target.dataset['piece'];
         if(this.support_format_webp)
        document.getElementById("visualiseur-image").style.backgroundImage = 'url("'+ process.env.PUBLIC_URL + '/visualiseur/' + this.gamme +"/" +this.pieceSelectionnee + '.webp")';
        else
         document.getElementById("visualiseur-image").style.backgroundImage = 'url("'+ process.env.PUBLIC_URL + '/visualiseur/' + this.gamme +"/" +this.pieceSelectionnee + '.png")';
        document.getElementById("visualiseur-image").style.backgroundPosition = "center";

         this.afficherCategoriesVisualiseur();

         this.produitsSelectionnes = [];
         this.afficherProduitsSelectionnes();
         this.affichageVisuelsInspi();
    }
    contiensNuance = (nuance, liste) =>{
        var i;
        for (i = 0; i < liste.length; i++) {
            if (liste[i].id === nuance.id) {
                return true;
            }
        }

        return false;
    }

    rechercheNuanceNom = (nom, liste) =>{
        if (liste != undefined) {
            var i;
            for (i = 0; i < liste.length; i++) {
                if (liste[i].nom === nom) {
                    return liste[i];
                }
            }
        }
        return false;
    }

    rechercheNuanceHexa = (hexa, liste) =>{
        if (liste != undefined) {
            var i;
            for (i = 0; i < liste.length; i++) {
                if (liste[i].hexa === hexa) {
                    return liste[i];
                }
            }

            return false;
        }
        return false;
    }

    rechercheProduitsCategorie = (categorie, liste)  =>{
        if (liste != undefined) {
            var i;
            for (i = 0; i < liste.length; i++) {
                if (liste[i].nom === categorie) {
                    return liste[i];
                }
            }
        }
        return false;
    }

     rechercheProduitsId = (id, produits) =>{
        if (produits != undefined) {
            var i;
            for (i = 0; i < produits.length; i++) {
                if (produits[i].id === id) {
                    return produits[i];
                }
            }
        }
        return false;
    }

    rechercheCategorieId = (id) => {
        if (  this.pieces[this.pieceSelectionnee].emplacements != undefined) {
            this.i = 0
            this.emplacements = this.pieces[this.pieceSelectionnee].emplacements;
            return this.emplacements[id];
        }
        return false;
    }
    support_format_webp =() =>
    {
        var elem = document.createElement('canvas');

        if (!!(elem.getContext && elem.getContext('2d')))
        {
            // was able or not to get WebP representation
            return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
        }
        else
        {
            // very old browser like IE 8, canvas not supported
            return false;
        }
    }

     afficherNuanceVisualiseur = (e) => {

        var categorie = e.target.parentElement.dataset['categorie'];
        var nuance = e.target.parentElement.dataset['nuance'];
        var nuance_r = e.target.parentElement.dataset['nuance_r'];
        var nuance_v = e.target.parentElement.dataset['nuance_v'];
        var nuance_b = e.target.parentElement.dataset['nuance_b'];
        var nuance_nom = e.target.parentElement.dataset['nuanceTexte'];
       var nom_div = 'visualiseur-' + this.pieceSelectionnee + '-' + categorie;
       if(nuance !=null)
       {
           if(this.support_format_webp)
           var nom_fichier = this.pieceSelectionnee + '-' + categorie + '-' + nuance.split('#')[1] + '.webp';
           else
           var nom_fichier = this.pieceSelectionnee + '-' + categorie + '-' + nuance.split('#')[1] + '.png';
           $('#' + nom_div).remove();
           
           var colorIndex =  Math.round(((nuance_r * 299) + (nuance_v*587)  + (nuance_b  * 114)) /1000);
           
           if(colorIndex>125){
            var html = "<div class='visualiseur-image' id='" + nom_div + "' style='background-position:center;background-image: url(" + process.env.PUBLIC_URL + '/visualiseur/' + this.gamme + '/' +  nom_fichier.toLowerCase() + ')' + "'></div><div class='visualiseur-nuancier-texte-nuance' style='Background-color:rgb("+ nuance_r+","+nuance_v+","+nuance_b +");color:back!important'data-nuancier-texte-id='" + categorie + "'></div>";
           }else{
            html = "<div class='visualiseur-image' id='" + nom_div + "' style='background-position:center;background-image: url(" + process.env.PUBLIC_URL + '/visualiseur/' + this.gamme + '/' +  nom_fichier.toLowerCase() + ')' + "'></div><div class='visualiseur-nuancier-texte-nuance' style='Background-color:rgb("+ nuance_r+","+nuance_v+","+nuance_b +");color:white!important'data-nuancier-texte-id='" + categorie + "'></div>";
           }
          
           $('#visualiseur-image').append(html);

            $('[data-nuancier-texte-id="' + categorie + '"]').text( nuance_nom);
           
           var produits_categorie = this.rechercheProduitsCategorie(categorie, this.produitsSelectionnes);
           if (!produits_categorie) {
               this.produitsSelectionnes.push({
                   "nuance": nuance,
                   "nom": categorie,
                   "produits": e.target.parentElement.dataset['produits']
               });
           }
           else {
               var index_liste = this.produitsSelectionnes.indexOf(produits_categorie);
               this.produitsSelectionnes.splice(index_liste, 1);
               this.produitsSelectionnes.push({
                   "nuance": nuance,
                   "nom": categorie,
                   "produits": e.target.parentElement.dataset['produits']
               });
           }

           this.afficherProduitsSelectionnes();
       }

    }

     afficherCategoriesVisualiseur = (nuance) => {
        var html = "";
        for (var categorie in this.pieces[this.pieceSelectionnee].emplacements) {

            if (this.pieces[this.pieceSelectionnee].emplacements.hasOwnProperty(categorie)) {
                console.log(categorie + " -> " + this.pieces[this.pieceSelectionnee].emplacements[categorie]);

                if (this.pieces[this.pieceSelectionnee].emplacements[categorie].nuances.length !== 0)
                    // html += '<label class="container-radio">' + this.pieces[this.pieceSelectionnee].emplacements[categorie].nom + '<input type="radio" class="visualiseur-categories-categorie" name="categorie-radio" value="' + categorie + '"/><span class="checkmark"></span></label>\n';
                    html +='<div class="ligneradio"><label class="container-radio"><input type="radio" class="visualiseur-categories-categorie" name="categorie-radio" value="' + categorie + '"/><span class="checkmark"></span></label><div class="name">' + this.pieces[this.pieceSelectionnee].emplacements[categorie].nom + '</div></div>\n';

            }
        }
        $("#visualiseur-liste-categories").empty();
        $("#visualiseur-liste-categories").html(html);

        $('.visualiseur-categories-categorie').bind('click', function (event) {
            this.afficherNuanceCategorieVisualiseur(document.querySelector('input[name="categorie-radio"]:checked').value);
        }.bind(this));
        /*for (var categorie in pieces[pieceSelectionnee].emplacements) {


            afficherNuanceCategorieVisualiseur(categorie);
        }*/
    }

     prechargerImage = (e) => {
        var categorie = e.target.parentElement.dataset['categorie'];
        var nuance = e.target.parentElement.dataset['nuance'];
        var nuance_nom = e.target.parentElement.dataset['nuanceTexte'];
        if (nuance != undefined) {
            if(this.support_format_webp)
            var nom_fichier = this.pieceSelectionnee + '-' + categorie + '-' + nuance.split('#')[1] + '.webp';
            else
            var nom_fichier = this.pieceSelectionnee + '-' + categorie + '-' + nuance.split('#')[1] + '.png';

            var my_image = new Image();

            // load the image
            my_image.src =  process.env.PUBLIC_URL + "/visualiseur/"  + this.gamme  + "/"  + nom_fichier.toLowerCase();
        }
    }


     afficherNuanceProduitVisualiseur = (e) => {
        var id = e.target.dataset['id'];
        var html = "";
         this.produits[id].nuances.forEach(function (nuance) {
            
            html += "<div class=\"visualiseur-nuancier-nuance\"><div class=\"visualiseur-nuancier-nuance-couleur\" style=\"background-color: rgb(" + nuance.r + "," + nuance.g +"," + nuance.b + "\"></div>";
            html += "<div class=\"visualiseur-nuancier-nuance-texte\">" + nuance.nom + "</div></div>";
            
            

        });
        $("#visualiseur-nuances").empty();
        $("#visualiseur-nuances").html(html);
    }
    afficherNuanceCategorieVisualiseur = (categorie) =>  {
        var html = "";
        if (this.pieces[this.pieceSelectionnee].emplacements[categorie].nuances.length !== 0)
            html += '<div class="visualiseur-nuancier" >' +
                '          <div id="visualiseur-nuances" data-nuancier-id="' + categorie + '"></div>' +
                '<div style="clear: both;"></div> </div>';


        $("#visualiseur-nuanciers").empty();
        $("#visualiseur-nuanciers").html(html);
       var  html = "";
        var colors = [];
        $.each(this.pieces[this.pieceSelectionnee].emplacements[categorie].nuances, function (i, v) {
            var color = v;
            colors.push(color);
        }.bind(this));

        colors.forEach(function (nuance) {
            html += "<div class=\"visualiseur-nuancier-nuance\" data-nuance-texte=\"" + nuance.nom + "\" title='" + nuance.nom + "' data-produits='" + nuance.produits + "' data-nuance='" + nuance.hexa + "'data-nuance_r='" + nuance.r + "'  data-nuance_v='" + nuance.v + "' data-nuance_b='" + nuance.b + "' data-categorie='" + categorie + "'><div class=\"visualiseur-nuancier-nuance-couleur\" style=\"background-color: rgb(" + nuance.r + "," + nuance.v +"," + nuance.b + "\"></div></div>";

        });
        $('[data-nuancier-id="' + categorie + '"]').empty();
        $('[data-nuancier-id="' + categorie + '"]').html(html);
        $('.visualiseur-nuancier-nuance').bind('click', function (event) {
            this.afficherNuanceVisualiseur(event);
        }.bind(this));
       /* $('.visualiseur-nuancier-nuance').hover(function (event) {
            this.prechargerImage(event);
        }.bind(this));*/
    }

     afficherProduitsSelectionnes = () => {
        this.produitsAAfficher = [];
         this.produitsSelectionnes.forEach(function (p) {
             var pi = parseInt(p.produits);
             var produit = this.rechercheProduitsId(pi,this.produits);
             var produitClone = JSON.parse(JSON.stringify(p));
             produitClone.nuance = this.rechercheNuanceHexa(p.nuance,produit.nuances);
             produitClone.nom = this.pieces[this.pieceSelectionnee].emplacements[p.nom].nom;
            this.produitsAAfficher.push(produitClone);

        }.bind(this));

         this.setState({NbProduits: this.produitsAAfficher.length});
         return this.produitsAAfficher;
    }
     toBase64 = (str) => {
        return window.btoa(unescape(encodeURIComponent(str)));
    }
     clone = (obj)=> {
        if (null == obj || "object" != typeof obj) return obj;
        var copy = obj.constructor();
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        }
        return copy;
    }

     genererPdf =() =>{
        var json_pdf = [];
        var ps = [];
         this.produitsSelectionnes.forEach(function (p) {
            var p1 = this.clone(p);
            if(p.produits.match('/,/'))
            {

                p.produits.split(',').forEach(function (produit) {
                    var pi = parseInt(produit);
                    produit = this.produits[pi];
                    p1.produits = produit.id;
                });
                p1.produits = this.rechercheProduitsId(p.produit,this.produits);
            }
            ps.push(p1);
        });
        json_pdf = JSON.stringify([{produits: ps}, {piece: this.pieceSelectionnee}]);

        var win = window.open('https://order-distrib.v33.com/assets_v33fr/visualiseur/pdf/bilan_pdf.php?data=' + this.toBase64(json_pdf), '_blank');
        win.focus();
    }

     visualiseurSetData = (data,piece) => {
         this.visualiseurData = data;
         this.pieceSelectionnee = data.pieceParDefaut;
         this.gamme = data.gamme;
        setTimeout(() => {  this.generationNuances(); }, 300);
    }


// Triage des couleurs selon la valeur en HUE
    constructColor = function (colorObj) {
        //adapted from http://www.runtime-era.com/2011/11/grouping-html-hex-colors-by-hue-in.html
        var hex = colorObj.substring(1);
        console.log(hex);
        /* Get the RGB values to calculate the Hue. */
        var r = parseInt(hex.substring(0, 2), 16) / 255;
        var g = parseInt(hex.substring(2, 4), 16) / 255;
        var b = parseInt(hex.substring(4, 6), 16) / 255;

        /* Getting the Max and Min values for Chroma. */
        var max = Math.max.apply(Math, [r, g, b]);
        var min = Math.min.apply(Math, [r, g, b]);


        // /* Variables for HSV value of hex color. */
        var chr = max - min;
        var hue = 0;
        var val = max;
        var sat = 0;


        if (val > 0) {
            /* Calculate Saturation only if Value isn't 0. */
            sat = chr / val;
            if (sat > 0) {
                if (r == max) {
                    hue = 60 * (((g - min) - (b - min)) / chr);
                    if (hue < 0) {
                        hue += 360;
                    }
                } else if (g == max) {
                    hue = 120 + 60 * (((b - min) - (r - min)) / chr);
                } else if (b == max) {
                    hue = 240 + 60 * (((r - min) - (g - min)) / chr);
                }
            }
        }
        colorObj.chroma = chr;
        colorObj.hue = hue;
        colorObj.sat = sat;
        colorObj.val = val;
        colorObj.luma = .3 * r + .59 * g + .11 * b
        colorObj.red = r;
        colorObj.green = g;
        colorObj.blue = b;
        return colorObj;
    }

     Color = function Color(hexVal) { //define a Color class for the color objects
        this.hex = hexVal;
    }


     sortColorsByHue = function (colors) {
        /* Sort by Hue. */
        return colors.sort(function (a, b) {
            return b.val - a.val;
        });
    };

}

export default withRouter(VisualiseurV33);